module.exports = __webpack_public_path__ + "static/media/googleBooksS.c62dc5f2.png";